/* eslint-disable import/named */
import { call, put, takeEvery } from 'redux-saga/effects';
import { Redirect as AppRedirect } from '@shopify/app-bridge/actions';

import * as services from './service';
import { Service } from './service';

import * as Notification from './notification-saga';

import * as types from '../constants';

function* getShopInfo() {
  try {
    const data = yield call(Service.getShopInfo);
    yield put({ type: types.SET_SHOP_INFO, data });
  } catch (error) {
    yield put({ type: types.SET_SHOP_INFO, error });
  }
}

export function* getListBlog(actions) {
  const response = yield call(services.getListBlogServer, actions.number);
  if (response) {
    yield put({
      type: types.GET_LIST_BLOG_RESULT,
      payload: response
    });
  } else {
    console.log(response);
  }
}

export function* getListNotificationSaga(data) {
  const response = yield call(Notification.getListNotificationService, data.shop);
  if (response) {
    yield put({
      type: types.GET_LIST_NOTIFICATION_RESULT,
      payload: response
    });
  } else {
    console.log(response);
  }
}

export function* getNotificationDetailSaga(data) {
  const response = yield call(Notification.getNotificationDetailService, data.shop, data.id);
  if (response) {
    yield put({
      type: types.GET_NOTIFICATION_DETAIL_RESULT,
      payload: response
    });
  } else {
    console.log(response);
  }
}

export function* updateNotificationSaga(data) {
  const response = yield call(Notification.updateNotificationService, data.shop, data.id);
  if (response) {
    yield put({
      type: types.GET_LIST_NOTIFICATION,
      shop: data.shop
    });
  } else {
    console.log(response);
  }
}

export function* upgradePackagePro(payload) {
  try {
    const data = yield call(Service.upgradePackagePro, payload);
    if (data.confirmation_url) {
      window.redirect.dispatch(AppRedirect.Action.REMOTE, data.confirmation_url);
    }
  } catch (error) {
    yield put({ type: types.UPGRADE_PACKAGE_PRO_RESPONSE, error });
  }
}

export function* downgradePackagePro() {
  try {
    const data = yield call(Service.downgradePackagePro);
    yield put({ type: types.UPGRADE_PACKAGE_PRO_RESPONSE, data });
  } catch (error) {
    yield put({ type: types.UPGRADE_PACKAGE_PRO_RESPONSE, error });
  }
}

export function* getCurrencyRate() {
  const response = yield call(Notification.getCurrencyRate);
  if (response) {
    yield put({
      type: types.GET_CURRENCY_RATE_RESPONSE,
      payload: response
    });
  } else {
    console.log(response);
  }
}

export function* getShopSettings() {
  try {
    const data = yield call(Service.getShopSettings);
    yield put({ type: types.SET_SHOP_SETTINGS, data });
  } catch (error) {
    yield put({ type: types.SET_SHOP_SETTINGS, error });
  }
}

export function* saveSettingsCurrency(action) {
  try {
    const data = yield call(Service.saveCurrencySetting, action);
    yield put({ type: types.SAVE_SETTINGS_RESPONSE, data });
    if (data.success === true) {
      const data = yield call(Service.getShopSettings);
      const checkCode = true;
      yield put({ type: types.SET_SHOP_SETTINGS, data, checkCode });

      // Update trạng thái saved để show form ask for review
      yield put({ type: types.UPDATE_IS_SAVED });
    }
  } catch (error) {
    yield put({ type: types.SAVE_SETTINGS_RESPONSE, error });
  }
}

export function* getShopSettingsTranslate() {
  const data = yield call(Service.getShopSettingsTranslate);
  const dataCurrency = yield call(Service.getShopSettings);
  yield put({ type: types.SET_SHOP_SETTINGS_TRANSLATE, data, dataCurrency });
}

export function* getCountTolal() {
  try {
    const data = yield call(Service.getCountTolal);
    yield put({ type: types.SET_COUNT_TOTAL, data });
  } catch (error) {
    yield put({ type: types.SET_COUNT_TOTAL, error });
  }
}

export function* getDateTime(actions) {
  try {
    const data = yield call(Service.getDateTime, actions.payload);
    yield put({ type: types.SET_DATE_TIME, data });
  } catch (error) {
    yield put({ type: types.SET_DATE_TIME, error });
  }
}

export function* saveSettingsTranslate(action) {
  try {
    const data = yield call(Service.saveTranslateSetting, action);
    yield put({ type: types.SAVE_SETTINGS_RESPONSE_TRANSLATE, data });
    if (data.success === true) {
      const data = yield call(Service.getShopSettingsTranslate);
      const checkCode = true;
      yield put({ type: types.SET_SHOP_SETTINGS_TRANSLATE, data, checkCode });
      // Update trạng thái saved để show form ask for review
      yield put({ type: types.UPDATE_IS_SAVED });
    }
  } catch (error) {
    yield put({ type: types.SAVE_SETTINGS_RESPONSE_TRANSLATE, error });
  }
}

function* upgradePlanPackageSaga(payload) {
  const data = payload.plan;
  const response = yield call(services.upgradePlanPackageService, data);
  if (response && response.confirmation_url) {
    window.location.href = response.confirmation_url;
  } else {
    window.location.href = '';
  }
}

export function* changeAppStatusSaga(data) {
  const response = yield call(services.changeAppStatusService, data.status);
  if (response && response.success) {
    yield put({
      type: types.CHANGE_APP_STATUS_RESULT,
      res: { result: 1, status: data.status }
    });
  } else {
    yield put({
      type: types.CHANGE_APP_STATUS_RESULT,
      res: { result: 2, status: !data.status }
    });
  }
}

export function* changeAppStatusCurrencySaga(data) {
  const response = yield call(services.changeAppStatusCurrencyService, data.status);
  if (response && response.success) {
    yield put({
      type: types.CHANGE_APP_STATUS_CURRENCY_RESULT,
      res: { result: 1, status: data.status }
    });
  } else {
    yield put({
      type: types.CHANGE_APP_STATUS_CURRENCY_RESULT,
      res: { result: 2, status: !data.status }
    });
  }
}

export function* changeAppStatusTranslateSaga(data) {
  const response = yield call(services.changeAppStatusTranslateService, data.status);
  if (response && response.success) {
    yield put({
      type: types.CHANGE_APP_STATUS_TRANSLATE_RESULT,
      res: { result: 1, status: data.status }
    });
  } else {
    yield put({
      type: types.CHANGE_APP_STATUS_TRANSLATE_RESULT,
      res: { result: 2, status: !data.status }
    });
  }
}

function* sagaActions() {
  yield takeEvery(types.GET_LIST_BLOG, getListBlog);
  yield takeEvery(types.SAVE_SETTINGS_CURRENCY, saveSettingsCurrency);

  yield takeEvery(types.CHANGE_APP_STATUS, changeAppStatusSaga);
  yield takeEvery(types.CHANGE_APP_STATUS_CURRENCY, changeAppStatusCurrencySaga);
  yield takeEvery(types.CHANGE_APP_STATUS_TRANSLATE, changeAppStatusTranslateSaga);

  yield takeEvery(types.GET_LIST_NOTIFICATION, getListNotificationSaga);
  yield takeEvery(types.UPDATE_NOTIFICATION, updateNotificationSaga);

  yield takeEvery(types.GET_SHOP_SETTINGS, getShopSettings);
  yield takeEvery(types.UPGRADE_PACKAGE_PRO, upgradePackagePro);
  yield takeEvery(types.DOWNGRADE_PACKAGE_PRO, downgradePackagePro);
  yield takeEvery(types.GET_CURRENCY_RATE, getCurrencyRate);
  yield takeEvery(types.SAVE_SETTINGS_TRANSLATE, saveSettingsTranslate);
  yield takeEvery(types.GET_SHOP_SETTINGS_TRANSLATE, getShopSettingsTranslate);
  yield takeEvery(types.GET_COUNT_TOTAL, getCountTolal);
  yield takeEvery(types.GET_DATE_TIME, getDateTime);
  yield takeEvery(types.UPGRADE_PALN_PACKAGE, upgradePlanPackageSaga);
  yield takeEvery(types.GET_SHOP_INFO, getShopInfo);
}

export default sagaActions;
